// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../Types/generated-types'

import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type RecentBookingsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.BookingsPagination>
}>

export type RecentBookingsQuery = {
  __typename?: 'Query'
  recentBookings: Array<{
    __typename?: 'Booking'
    id: number
    name: string
    location: string
    country: string
    lat: number
    lon: number
    radius: number
    fromDateTime: any
    attendees: number
    budget: number
    currency: Types.SupportedCurrencyCode
    layoutId: string
    cateringNeeds?: string | null
    additionalNotes?: string | null
    isFlexibleWithDates: boolean
    flexibleDatesNote?: string | null
    eventType?: { __typename?: 'Collection'; id: number } | null
    styles: Array<{ __typename?: 'Style'; id?: Types.StyleId | null }>
    spaceFacilities: Array<{ __typename?: 'SpaceFacility'; id?: number | null }>
    event: {
      __typename?: 'Event'
      locationPolygon?: string | null
      venueRequests: Array<{
        __typename?: 'VenueRequest'
        id: number
        spaceId: number
        space?: {
          __typename?: 'SelfServeSpace'
          ID?: number | null
          spaceName?: string | null
          spacePhotos?: Array<{
            __typename?: 'SelfServeSpacePhoto'
            url?: string | null
            position?: number | null
          }> | null
          venue?: {
            __typename?: 'SelfServeVenue'
            name?: string | null
            latitude?: number | null
            longitude?: number | null
          } | null
          hostContact: { __typename?: 'HostContact'; id?: number | null }
        } | null
      }>
      invitations: Array<{
        __typename?: 'Invitation'
        ID: number
        recipientId: number
        recipientType: Types.ServiceProviderType
        declinedAt?: string | null
        declinedReason?: Types.InvitationDeclinedReason | null
      }>
      owner?: { __typename?: 'User'; firstName: string; lastName: string } | null
    }
    requestedToBookProposal?: {
      __typename?: 'Proposal'
      space?: {
        __typename?: 'SelfServeSpace'
        ID?: number | null
        spaceName?: string | null
        spacePhotos?: Array<{
          __typename?: 'SelfServeSpacePhoto'
          url?: string | null
          position?: number | null
        }> | null
        venue?: {
          __typename?: 'SelfServeVenue'
          name?: string | null
          city?: string | null
          addressLine1?: string | null
          latitude?: number | null
          longitude?: number | null
        } | null
        hostContact: { __typename?: 'HostContact'; id?: number | null }
      } | null
    } | null
  }>
}

export const RecentBookingsDocument = gql`
  query RecentBookings($pagination: BookingsPagination) {
    recentBookings(pagination: $pagination) {
      id
      name
      location
      country
      lat
      lon
      radius
      fromDateTime
      attendees
      budget
      currency
      layoutId
      cateringNeeds
      additionalNotes
      isFlexibleWithDates
      flexibleDatesNote
      eventType {
        id
      }
      styles {
        id
      }
      spaceFacilities {
        id
      }
      event {
        locationPolygon
        venueRequests {
          id
          spaceId
          space {
            ID
            spaceName
            spacePhotos {
              url
              position
            }
            venue {
              name
              latitude
              longitude
            }
            hostContact {
              id
            }
          }
        }
        invitations {
          ID
          recipientId
          recipientType
          declinedAt
          declinedReason
        }
        owner {
          firstName
          lastName
        }
      }
      requestedToBookProposal {
        space {
          ID
          spaceName
          spacePhotos {
            url
            position
          }
          venue {
            name
            city
            addressLine1
            latitude
            longitude
          }
          hostContact {
            id
          }
        }
      }
    }
  }
`

export function useRecentBookingsQuery(
  options?: Omit<Urql.UseQueryArgs<RecentBookingsQueryVariables>, 'query'>
) {
  return Urql.useQuery<RecentBookingsQuery, RecentBookingsQueryVariables>({
    query: RecentBookingsDocument,
    ...options,
  })
}
